import { render, staticRenderFns } from "./border-list.vue?vue&type=template&id=7a29da1a&scoped=true&"
import script from "./border-list.vue?vue&type=script&lang=js&"
export * from "./border-list.vue?vue&type=script&lang=js&"
import style0 from "./border-list.vue?vue&type=style&index=0&id=7a29da1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a29da1a",
  null
  
)

export default component.exports